"use strict";

// add a parameter to array on click on $('.js-checkbox-panel') when checked is true
function addParametersToArray(array, elem, parameterUrl) {
  array.push(elem);
  setGetParameter(parameterUrl, array.join(','));
} // remove a parameter to array on click on $('.js-checkbox-panel') when checked is false


function removeParametersToArray(array, elem, parameterUrl) {
  array.splice($.inArray(elem, array), 1);
  setGetParameter(parameterUrl, array.join(','));
}

function findGetParameter(parameterName) {
  var result = '',
      tmp = [];
  var items = location.search.substr(1).split("&");

  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }

  return result;
}

function setGetParameter(paramName, paramValue) {
  var url = window.location.href;
  var hash = location.hash;
  url = url.replace(hash, '');

  if (url.indexOf(paramName + "=") >= 0) {
    var prefix = url.substring(0, url.indexOf(paramName));
    var suffix = url.substring(url.indexOf(paramName));
    suffix = suffix.substring(suffix.indexOf("=") + 1);
    suffix = suffix.indexOf("&") >= 0 ? suffix.substring(suffix.indexOf("&")) : "";
    url = prefix + paramName + "=" + paramValue + suffix;
  } else {
    if (url.indexOf("?") < 0) url += "?" + paramName + "=" + paramValue;else url += "&" + paramName + "=" + paramValue;
  }

  update_url(url);

  if (document.getElementById("app_estate")) {
    vueEstates.loadEstateAds();
  }

  if (document.getElementById("app_blog")) {
    vueBlog.loadArticles();
  }

  if (document.getElementById("app_jobs")) {// vueJob.loadJobs();
  }
}